//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'dice',
  props: {
    /** 骰子大小 */
    size: {
      type: Number,
      default: 100
    },
    /** 默认一开始在哪个点数 */
    defaultPoint: {
      type: Number,
      default: null
    },
    /** 骰子动画时长 */
    duration: {
      type: Number,
      default: 2.5
    },
    /** 骰子面颜色 */
    faceColor: {
      type: String,
      default: '#ffffff'
    },
    /** 骰子面阴影颜色 */
    faceShadowColor: {
      type: String,
      default: '#ececec'
    },

    /** 骰子内部颜色 */
    insideColor: {
      type: String,
      default: '#f2f2f2'
    },
    /** 骰子点颜色 */
    dotColor: {
      type: String,
      default: '#333333'
    },
    /** 骰子点阴影颜色 */
    dotShadowColor: {
      type: String,
      default: '#000000'
    },
    /** 1点 颜色 */
    firstDotColor: {
      type: String,
      default: '#CB1717'
    },
    /** 1点 阴影颜色 */
    firstDotShadowColor: {
      type: String,
      default: '#530b0b'
    },
    // 是否能点击
    isclick: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentClass () {
      return (i) => {
        return { current: this.point === i }
      }
    },
    // 骰子组件样式
    diceStyle () {
      return `--diceSize: ${this.size}px;
        --faceColor:${this.faceColor};
        --faceShadowColor:${this.faceShadowColor};
        --insideColor:${this.insideColor};
        --dotColor:${this.dotColor};
        --dotShadowColor:${this.dotShadowColor};
        --firstDotColor:${this.firstDotColor};
        --firstDotShadowColor:${this.firstDotShadowColor};
        --faceBorderRadius: ${this.size / 5}px;
        --frontFaceShadowBlur:${this.size < 25 ? 4 : (this.size / 25)}px;
        --faceShadowBlur:${(this.size < 25 ? 4 : (this.size / 25)) * 6}px;`
    },
    // 整个立方体的样式
    cubeStyle () {
      return `--cubeTop:${this.size * 0.15}px;
        --cubeLeft:${this.size * 0.15}px;
        --duration: ${this.duration}s;`
    },
    // 面的样式
    faceStyle () {
      return `--zOffset:${this.size / 2};`
    },
    // 内部面（即每一个面的背面）的样式
    innerFaceStyle () {
      return `--zOffset:${this.size / 2 - 1};`
    },
    // 点的样式
    dotStyle () {
      return (face, i) => {
        const dotSize = face === 1 ? this.size * 0.25 : this.size * 0.15
        const start = this.size * 0.225
        const middle = this.size * 0.425
        const end = this.size * 0.625
        const positions = {
          1: [[this.size / 2 - dotSize / 2, this.size / 2 - dotSize / 2]],
          2: [[middle, start], [middle, end]],
          3: [[start, start], [middle, middle], [end, end]],
          4: [[start, start], [end, start], [start, end], [end, end]],
          5: [[start, start], [end, start], [middle, middle], [start, end], [end, end]],
          6: [[start, start], [end, start], [start, middle], [end, middle], [start, end], [end, end]]
        }
        const position = positions[face][i - 1]
        return `--dotSize:${Math.floor(dotSize)}px;
          --dotLeft:${position[0]}px;
          --dotTop:${position[1]}px;
          --dotShadowX:${dotSize / 6}px;
          --dotShadowBlur:${dotSize / 3}px;`
      }
    },
    // x、y、z三个切面的样式
    sectionStyle () {
      const margin = 1
      const sectionSize = this.size - (margin * 2)
      return `--sectionSize:${sectionSize}px;
              --sectionMargin:${margin}px;
              `
    }
  },
  data () {
    return {
      isTurning: false, // 是否正在转动
      minTurns: 1, // 最少转 1 圈
      maxTurns: 12, // 最多转 12 圈
      minPoint: 1, // 最小 1 点
      maxPoint: 6, // 最大 6 点
      point: this.defaultPoint || 1 // 停在 n 点，随机范围：[1, 6]
    }
  },
  mounted () {
    this.anim(false)
  },
  methods: {
    /** 更新骰子面 */
    update () {
      if (this.isTurning || !this.isclick) {
        return
      }
      this.isTurning = true
      // 每点击一次，随机更改一个面
      this.point = parseInt(Math.random() * (this.maxPoint - this.minPoint + 1) + this.minPoint, 10)
      this.$emit('immediate', this.point)
      this.anim(true)
    },
    /** 滚动骰子 */
    anim (clicked) {
      const randReg = this.getRotateRegByPoint()
      if (!randReg) {
        return
      }
      this.$refs.cube.style.webkitTransform = `rotateX(${randReg.x}deg) rotateY(${randReg.y}deg)`
      this.$refs.cube.style.transform = `rotateX(${randReg.x}deg) rotateY(${randReg.y}deg)`
      if (!clicked) {
        return
      }
      // 动画执行完毕，触发事件更新点数
      setTimeout(() => {
        this.$emit('on-dice-update', this.point)
        this.isTurning = false
      }, this.duration * 1000)
    },
    /** 获取当前骰子点数 */
    getCurrentPoint () {
      return this.point
    },
    /** 根据指定的点数，随机生成旋转角度 */
    getRotateRegByPoint () {
      switch (this.point) {
        case 1: // front
          return { x: this.randomReg(), y: this.randomReg() }
        case 2: // right
          return { x: this.randomReg(), y: this.randomReg() - 90 }
        case 3: // top
          return { x: this.randomReg() - 90, y: this.randomReg() }
        case 4: // bottom
          return { x: this.randomReg() + 90, y: this.randomReg() }
        case 5: // left
          return { x: this.randomReg(), y: this.randomReg() + 90 }
        case 6: // back
          return { x: this.randomReg(), y: this.randomReg() + 180 }
        default:
          console.error('点数的取值范围为[1, 6]')
          return null
      }
    },
    /** 随机角度 */
    randomReg () {
      return (Math.floor(Math.random() * (this.maxTurns - this.minTurns)) + this.minTurns) * 360
    }
  }
}
